import React, { useEffect, useState } from "react";
import { SketchPicker,HuePicker } from "react-color";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import "./ColorPalette.css";
import RangeSliderBasic from "../RangeSliderBasic";
import RangeSliderColorAlpha from "../RangeSliderColorAlpha";
import { Minus, Plus, Square, Squircle } from "lucide-react";
import RangeSliderDynamic from "../RangeSliderDynamic";
const  ColorPickerGradientDynamic =({activeColorPickerValue,setActiveColorPickerValue,palletTitle}) =>{
  const [color1, setColor1] = useState(activeColorPickerValue?.color1?activeColorPickerValue?.color1:"rgba(1,1,1,0.051)");
  const [color2, setColor2] = useState(activeColorPickerValue?.color2?activeColorPickerValue?.color2:"rgba(1,1,1,0.051)");
  const [color1Hex, setColor1Hex] = useState(rgbaToHex(activeColorPickerValue?.color1?activeColorPickerValue?.color1:"rgba(1,1,1,0.051)"));
 const [color2Hex, setColor2Hex] = useState(rgbaToHex(activeColorPickerValue?.color2?activeColorPickerValue?.color2:"rgba(1,1,1,0.051)"));
 const [color1Changed, setColor1Changed] = useState(rgbaToHex(activeColorPickerValue?.color1?activeColorPickerValue?.color1:"rgba(1,1,1,0.051)"));
 const [color2Changed, setColor2Changed] = useState(rgbaToHex(activeColorPickerValue?.color2?activeColorPickerValue?.color2:"rgba(1,1,1,0.051)"));
  const [location1, setLocation1] = useState((activeColorPickerValue?.location1?activeColorPickerValue?.location1:"30"));
 const [location2, setLocation2] = useState((activeColorPickerValue?.location2?activeColorPickerValue?.location2:"50"));
 const [angle, setAngle] = useState((activeColorPickerValue?.angle?activeColorPickerValue?.angle:"50"));
 const [gradientType, setGradientType] = useState((activeColorPickerValue?.gradientType?activeColorPickerValue?.gradientType:"linear"));
  
  
                          const colorPickerOptionArray =[     
                                  'rgba(246, 144, 130,1)',      
                              'rgba(188, 176, 221,1)', ,       
                              'rgba(194, 175, 117,1)',
                                   
                            'rgb(152, 247, 239)',    
                              'rgb(254, 184, 98)'      
                              , 'rgb(171, 249, 165)',  
                                   
                            'rgb(237, 246, 115)',    
                              'rgb(106, 211, 141)'      
                              , 'rgb(186, 181, 244)',  
                                   
                            'rgb(239, 149, 240)',    
                              'rgba(211, 164, 106,1)'      
                              , 'rgb(245, 132, 142)',       
                              'rgb(253, 255, 255)',       
                              'rgb(19, 20, 20)'  ];
                              
  const dispatch = useDispatch();
     
      const [activeColor1,setActiveColor1] = useState(activeColorPickerValue?.color1?activeColorPickerValue?.color1:activeColorPickerValue)
const [activeColor2,setActiveColor2] = useState(activeColorPickerValue?.color2?activeColorPickerValue?.color2:activeColorPickerValue)
     const [alpha,setAlpha] = useState(activeColorPickerValue?.alpha?activeColorPickerValue?.alpha:1)
const [palletStatus,setPalletStatus] = useState(true)
function generateColorShades(rgbaColor) {
  const match = rgbaColor.match(/rgba?\s*\(\s*(\d+),\s*(\d+),\s*(\d+),?\s*([0-9.]+)?\s*\)/);

  if (!match) {
    throw new Error("Invalid rgba color format");
  }

  const [_, r, g, b, a] = match;
  const red = parseInt(r);
  const green = parseInt(g);
  const blue = parseInt(b);
  const alpha = parseFloat(a ?? 1); // default to 1 if alpha is missing

  const result = { alpha: alpha };
  for (let i = 1; i <= 10; i++) {
    const newAlpha = (i / 10).toFixed(1);
    result[`color${i}`] = `rgba(${red}, ${green}, ${blue}, ${newAlpha})`;
  }

  return result;
}
     useEffect(()=>{
       setPalletStatus(false)
   setTimeout(()=>{  setPalletStatus(true)

   },0)
     },[  ])
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
     const handleChange1 = (newColor) => {
    setColor1(hexToRgba(newColor?.hex)); setColor1Changed(newColor);
  let rgbacolor1= hexToRgba(newColor?.hex);
 setColor1Hex((newColor?.hex));
    if(gradientType=="linear"){ 
    setActiveColorPickerValue({color:`linear-gradient(to right,  ${rgbacolor1} ${location1}% , ${color2} ${location2}%)`,color1:rgbacolor1,color2:color2,alpha:alpha,colors:generateColorShades(rgbacolor1)});
  
     }
     if(gradientType=="conic"){ 
   
setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}%,   ${rgbacolor1} ${location1}% , ${color2} ${location2}% )`,color1:rgbacolor1,color2:color2,alpha:alpha,colors:generateColorShades(color1)})
       }
    
    };
  const handleChange2 = (newColor) => {
    setColor2(hexToRgba(newColor?.hex)); setColor2Changed(newColor);
  let rgbacolor2= hexToRgba(newColor?.hex);
 setColor2Hex((newColor?.hex)); 
     if(gradientType=="linear"){ 
    setActiveColorPickerValue({color:`linear-gradient(to right,   ${color1} ${location1}% , ${rgbacolor2} ${location2}% )`,color1:color1,color2:rgbacolor2,alpha:alpha,colors:generateColorShades(color1)});
     }
       if(gradientType=="conic"){ 
   
setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}%,   ${color1} ${location1}% , ${rgbacolor2} ${location2}% )`,color1:color1,color2:rgbacolor2,alpha:alpha,colors:generateColorShades(color1)})
       }
};
 

  function hexToRgba(hex) {
  // Remove the # if present
  hex = hex?.replace(/^#/, "");

  if (![3, 4, 6, 8].includes(hex?.length)) {
    // throw new Error("Invalid HEX color format");
  }

  // Expand short hex (e.g., #abc or #abcd) to full form
  if (hex?.length === 3 || hex?.length === 4) {
    hex = hex?.split("").map(char => char + char).join("");
  }

  // Extract RGB components
  const r = parseInt(hex?.slice(0, 2), 16);
  const g = parseInt(hex?.slice(2, 4), 16);
  const b = parseInt(hex?.slice(4, 6), 16);

  // Extract Alpha if present
  let a = alpha;
  if (hex?.length === 8) {
    a = parseInt(hex.slice(6, 8), 16) / 255;
    a = Math.round(a * 100) / 100; // Round to 2 decimal places
  }

  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
  function rgbaToHex(rgba) {
    // Extract RGBA values using regex
    const match = rgba?.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d\.]+)?\)/);
  
    if (!match) { return
    //   throw new Error("Invalid RGBA color format");
    }
  
    let r = parseInt(match[1]);
    let g = parseInt(match[2]);
    let b = parseInt(match[3]);
    let a = match[4] !== undefined ? parseFloat(match[4]) : 1;
  
    // Validate and clamp values
    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));
    a = Math.min(1, Math.max(0, a));
  
    // Convert RGB to HEX
    const hex = ((r << 16) | (g << 8) | b).toString(16).padStart(6, "0");
  
    // Convert Alpha to HEX (if less than 1)
    const alphaHex = a < 1 ? Math.round(a * 255).toString(16).padStart(2, "0") : "";
  
    return `#${hex}${alphaHex}`.toUpperCase();
  }
  

  return (<div className="colorPickerDynamicGradient" style={{boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)" ,overflow:"hidden",width:"340px",border:"3px solid rgba(144, 202, 249,1)",background:"#fff",padding: "8px",paddingTop:"3px", borderRadius:"20px" }}><h2>{palletTitle} Gradient</h2><div style={{display:"flex",justifyContent:"space-around"}}>
    <div style={{  width:"320px", display:"flex",justifyContent:"space-between" ,gap:"10px"}}>
      <div style={{borderRadius: "10px",width:"130px",height:"230px",border:"3px solid rgba(144, 202, 249,1)",padding:"10px",overflow:"hidden"}}>
     <SketchPicker color={color1Changed}
        onChange={handleChange1}
       
        disableAlpha // Hides the alpha slider
        presetColors={[]} // Remove preset colors
        
        styles={{
          default: {
            picker: {
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.01)",
              borderRadius: "10px",
              padding: "0px",
            },
          },
        }} />
        <div style={{padding: "5px",width:"120px",background:"#fff" }}>
        <div className="gridForColorBoxSquare" style={{marginTop:"-60px",width:"100%",marginLeft:"-30px"}}>
 
{colorPickerOptionArray.map((color, index) => (
        <div 
        onMouseEnter={()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave} 
        onClick={()=>{
           let hexMy= rgbaToHex(color)
            setAlpha(alpha); setColor1Changed(hexMy); setColor1((color));
            
            setColor1Hex(rgbaToHex(color));
            
            // setActiveColorPickerValue({color:hexToRgba(hexMy),alpha:alpha,colors:generateColorShades(hexToRgba(hexMy))});
             if(gradientType=="conic"){  setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}%,   ${hexToRgba(hexMy)} ${location1}% , ${color2} ${location2}% )`,color1:hexToRgba(hexMy),color2:color2,alpha:alpha,colors:generateColorShades(color1)})
 }
       if(gradientType=="linear"){ setActiveColorPickerValue({color:`linear-gradient(to right,   ${hexToRgba(hexMy)} ${location1}% , ${color2} ${location2}% )`,color1:hexToRgba(hexMy),color2:color2,alpha:alpha,colors:generateColorShades(color1)})}
             setPalletStatus(false)
   setTimeout(()=>{  setPalletStatus(true)

   },110)
        }}
          key={index} className="colorBoxSquare" style={{background:color,border:"3px solid #555",position:"relative",padding:"0px",borderRadius:"50%"}}> <div className="" style={{background:color,border:"4px solid #fff",width:"11px",height:"11px",padding:"2px",borderRadius:"50%"}}></div></div>))
          }
       
          
</div>
    </div>
         </div> <div style={{borderRadius: "10px",width:"130px",height:"230px",border:"3px solid rgba(144, 202, 249,1)",padding:"10px",overflow:"hidden"}}>
      <SketchPicker color={color2Changed}
        onChange={handleChange2}
       
        disableAlpha // Hides the alpha slider
        presetColors={[]} // Remove preset colors
        
        styles={{
          default: {
            picker: {
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.01)",
              borderRadius: "10px",
              padding: "0px",
            },
          },
        }} />
        <div style={{padding: "5px",width:"130px",background:"#fff" }}>
        <div className="gridForColorBoxSquare" style={{marginTop:"-60px",width:"100%",marginLeft:"-30px"}}>
 

          {colorPickerOptionArray.map((color, index) => (
        <div 
        onMouseEnter={()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave} 
        onClick={()=>{
           let hexMy= rgbaToHex(color)
            setAlpha(alpha); setColor2Changed(hexMy); setColor2((color));setColor2Hex(rgbaToHex(color));  
            // setActiveColorPickerValue({color:hexToRgba(hexMy),alpha:alpha,colors:generateColorShades(hexToRgba(hexMy))});
               if(gradientType=="conic"){  setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}%,   ${color1} ${location1}% , ${hexToRgba(hexMy)} ${location2}% )`,color1:color1,color2:hexToRgba(hexMy),alpha:alpha,colors:generateColorShades(color1)})
 }
       if(gradientType=="linear"){ setActiveColorPickerValue({color:`linear-gradient(to right,   ${color1} ${location1}% , ${hexToRgba(hexMy)} ${location2}% )`,color1:color1,color2:hexToRgba(hexMy),alpha:alpha,colors:generateColorShades(color1)})}
        
             setPalletStatus(false)
   setTimeout(()=>{  setPalletStatus(true)

   },110)
        }}
          key={index} className="colorBoxSquare" style={{background:color,border:"3px solid #555",position:"relative",padding:"0px",borderRadius:"50%"}}> <div className="" style={{background:color,border:"4px solid #fff",width:"11px",height:"11px",padding:"2px",borderRadius:"50%"}}></div></div>))
          }
          
</div>
    </div>
        {/* {palletStatus&&<RangeSliderColorAlpha  setSliderVal={(val)=>{  setAlpha(val);setActiveColorPickerValue({color:(`linear-gradient(to right, ${hexToRgba(color1Hex)},  ${hexToRgba(color2Hex)})`),color1:hexToRgba(color1Hex),color2:hexToRgba(color2Hex),alpha:alpha,colors:generateColorShades(hexToRgba(color2Hex))})}} showMarkerColor={(hexToRgba(color2Hex))}  sliderVal={alpha} />} */}
 </div>
      
     
     
     
 
    </div>
    
    </div>
    <div style={{  display:"flex",justifyContent:"space-between" ,gap:"10px"}}> 
    {palletStatus&&<RangeSliderColorAlpha  setSliderVal={(val)=>{  setAlpha(val);
           if(gradientType=="conic"){  setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}%,   ${hexToRgba(color1Hex)} ${location1}% , ${hexToRgba(color2Hex)} ${location2}% )`,color1:hexToRgba(color1Hex),color2:hexToRgba(color2Hex),alpha:alpha,colors:generateColorShades(color1)})
 }
       if(gradientType=="linear"){ 
         setActiveColorPickerValue({color:(`linear-gradient(to right, ${hexToRgba(color1Hex)},  ${hexToRgba(color2Hex)})`),color1:hexToRgba(color1Hex),color2:hexToRgba(color2Hex),alpha:1,colors:generateColorShades(hexToRgba(color1Hex))})
          } 
       }} showMarkerColor={"#222222"}  sliderVal={alpha} />}
          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                             <h5>Gradient Type: </h5>   <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                         Linear
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={gradientType=="linear"?"yes":""}
                   className="input-textbox"  value={"linear"}  name={"gradientType1"}   
                   onClick={e=>{setGradientType("linear");
                     setActiveColorPickerValue({color:`linear-gradient(to right,   ${color1} ${location1}% , ${color2} ${location2}% )`,color1:color1,color2:color2,alpha:alpha,colors:generateColorShades(color1)})
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}style={{height:"20px",marginTop:"10px"}}>
                                            <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                            
                                                 Conic                 
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={gradientType=="conic"?"yes":""}
                   className="input-textbox"  value="conic"  name={"gradientType1"}  
                   onChange={e=>{setGradientType("conic");
                     setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}%,   ${color1} ${location1}% , ${color2} ${location2}% )`,color1:color1,color2:color2,alpha:alpha,colors:generateColorShades(color1)})
 
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                       
                        </div> 
 
</div>
  <div style={{  display:"flex",justifyContent:"space-between" ,gap:"5px",padding:"10px"}}> 
 
 <RangeSliderDynamic   rangeIntervalType="location2Slider" rangeStart={1} rangeEnd={200} pxPerType={"%"}  
       setSliderVal={(value)=>{ setLocation1(value)
        if(gradientType=="conic"){setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}%,   ${color1} ${location1}% , ${color2} ${location2}% )`,color1:color1,color2:color2,alpha:alpha,colors:generateColorShades(color1)})}
       if(gradientType=="linear"){    setActiveColorPickerValue({color:`linear-gradient(to right,   ${color1} ${location1}% , ${color2} ${location2}% )`,color1:color1,color2:color2,alpha:alpha,colors:generateColorShades(color1)})}}}  sliderVal={""} />
 <RangeSliderDynamic   rangeIntervalType="location1Slider" rangeStart={1} rangeEnd={200} pxPerType={"%"}  
       setSliderVal={(value)=>{ setLocation2(value)
        if(gradientType=="conic"){  setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}%,   ${color1} ${location1}% , ${color2} ${location2}% )`,color1:color1,color2:color2,alpha:alpha,colors:generateColorShades(color1)})
 }
       if(gradientType=="linear"){ setActiveColorPickerValue({color:`linear-gradient(to right,   ${color1} ${location1}% , ${color2} ${location2}% )`,color1:color1,color2:color2,alpha:alpha,colors:generateColorShades(color1)})}  }}  sliderVal={""} />
     
{gradientType=="conic"?
   <div style={{margin: '5px' ,paddingLeft:"0px",width:"90px", display:"grid", gridTemplateColumns: "50% 30% 0%" ,alignItems:"center"  }}>
 <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{setAngle(parseInt(angle)>1?parseInt(angle)-10:10)
   setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}% ,   ${color1} ${location1}% , ${color2} ${location2}% )`,color1:color1,color2:color2,alpha:alpha,colors:generateColorShades(color1)})
   }} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
    <input onMouseEnter={handleMouseEnter} disabled
     onMouseLeave={handleMouseLeave}  value={parseInt(angle)} type="number"
          onChange={(e)=>{setAngle(parseInt(e.target.value));}}
          style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",
            padding:"0px",marginLeft:"5px",fontSize:"20px",color:"#555555 ",background:"#fff",fontWeight:"bolder",marginTop:"0px",}}
      />  <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{setAngle(parseInt(angle)<360?parseInt(angle)+10:10)
           setActiveColorPickerValue({color:`conic-gradient(from ${angle}deg at ${location1}%  ${location2}% ,   ${color1} ${location1}% , ${color2} ${location2}% )`,color1:color1,color2:color2,alpha:alpha,colors:generateColorShades(color1)})
 
      
      }}  style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
        
        
        
        </div> :""}
        </div> 
    </div>
  );
}

export default ColorPickerGradientDynamic;
